/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_ButtonInputs */

const fr_membership_plan_change_button = /** @type {(inputs: Membership_Plan_Change_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de formule`)
};

/**

* @param {Membership_Plan_Change_ButtonInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_button = /** @type {((inputs?: Membership_Plan_Change_ButtonInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_ButtonInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_button(inputs)
});